module.exports = __webpack_public_path__ + "img/farming_53.95ba4c56.png";